import 'styles/giveaway-fonts.module.css'
import Head from 'next/head'
import { PresalesLayout } from '@/layouts/PresalesLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getProjectPhase } from '@/services/ProjectsService/ProjectsService'
import { PhaseSlug, SweepstakeObject } from '@/types/codegen-federation'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildGiveawayView } from '@/views/GuildGiveawayView/GuildGiveawayView'

interface GiveawayPageProps {
  theatricalSlug: string
  sweepstake: SweepstakeObject
  phase: PhaseSlug | null
  hasUser: boolean
}

export const GiveawayPage: NextPageWithLayout<GiveawayPageProps> = ({ theatricalSlug, phase, sweepstake, hasUser }) => {
  return (
    <>
      <Head>
        <link
          rel="preload"
          href="https://images.angelstudios.com/raw/upload/v1750703334/angel-studios/fonts/woff2/compactacom-regular-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link rel="stylesheet" href="https://use.typekit.net/ljo6mjo.css" />
      </Head>
      <div className="font-compactaCom absolute inset-0 !top-0 !overflow-x-hidden bg-white lg:fixed">
        <GuildGiveawayView hasUser={hasUser} sweepstake={sweepstake} theatricalSlug={theatricalSlug} phase={phase} />
      </div>
    </>
  )
}

export const getServerSideProps = getServerSidePropsErrorHandler<GiveawayPageProps>(
  async ({ federationClient, locale, userId }) => {
    const sweepstake: SweepstakeObject = {
      endDate: '2026-01-31',
      slug: 'homestead-series',
      title: 'Homestead Series',
      value: {
        currencyAmount: 85000,
        currencyCode: 'USD',
      },
      rules: `* * * LIMIT OF 350 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR
        PAYMENT OF ANY KIND IS NECESSARY TO ENTER OR WIN. PURCHASE OR PAYMENT
        DOES NOT IMPROVE YOUR CHANCE OF WINNING. Homestead Series Sweepstakes
        Escape and Evade Sweepstakes is open to residents of the 50 US States & DC, 21 +, who have
        never been convicted of a felony or crime of moral turpitude. Void elsewhere & where prohibited.
        Ends 1/1/2026. Subject to Official Rules at bit.ly/HomesteadSweepstakes`,
      rulesUrl: 'https://certified.promotrust.com/AngelFilms/HomesteadSeriesSweepstakesEscapeandEvade/rules.pdf',
      status: 'LIVE',
      giveawayYoutubeId: 'rWArIju73dQ',
      projectName: 'Homestead Series',
      seoImageUrl: 'https://images.angelstudios.com/image/upload/v1764179483/homestead-giveaway/homesteadeande.png',
      startDate: '2025-11-26',
      trailerYoutubeId: 'MEv63uOkPvQ',
      winnerAnnouncedDate: '2026-02-01',
    }

    const [phase, translations] = await Promise.all([
      getProjectPhase(federationClient, 'homestead-series'),
      loadTranslations(locale, ['common', 'home', 'tickets', 'chatbot', 'account', 'giveaway', 'guild']),
    ])

    return {
      props: {
        hasUser: Boolean(userId),
        sweepstake,
        theatricalSlug: 'homestead-series',
        phase,
        ...translations,
      },
    }
  },
)

GiveawayPage.getLayout = (page) => {
  return <PresalesLayout isDarkMode={false}>{page}</PresalesLayout>
}
export default GiveawayPage
